<template>
  <interview-short-cut-container
    class="flex flex-1 flex-col"
    :style="'background-color: #ffffff'"
  >
    <DrugInteractionScreen
      v-if="consumerKey && customerId"
      :consumer-key="consumerKey"
      :customer-id="customerId"
      @track-products="$router.push({
        name: 'interview-instances.consumer-product-tracking',
        query: {...$route.query},
      })"
    />
  </interview-short-cut-container>
</template>

<script lang="ts" setup>
import InterviewShortCutContainer
    from '@/interview/components/instance-modal/short-cuts/InterviewShortCutContainer.vue';
import DrugInteractionScreen from '@/drug-interaction/views/DrugInteractionScreen.vue';
import {storeToRefs} from "pinia";
import {useInterviewStore} from "@/stores/interview-store";

const interviewStore = useInterviewStore();
const {consumerKey, customerId} = storeToRefs(interviewStore);
</script>
